module.exports = __webpack_public_path__ + "static/media/youtube.a0975e36.svg";